import {connect} from "react-redux";
import TeamDetailsTable from "../Components/TeamDetailsTable.jsx";

const mapStateToProps = (state) => {
    return {
        stages: state.teamDetails.perStage && state.teamDetails.stages,
        achievements: state.teamDetails.achievements,
        team: state.teamDetails.team,
        columns: state.teamDetails.columns,
        activeStage: state.teamDetails.activeStage,
        game: state.games.current,
        startlist: state.teamDetails.Startlist,
    };
};


const TeamDetailsTableContainer = connect(
    mapStateToProps
)(TeamDetailsTable);

export default TeamDetailsTableContainer